import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export function useCampaigns(workspaceId) {
  return useQuery({
    queryKey: ["campaigns", workspaceId],
    queryFn: async () => (await api.get(`/api/workspaces/${workspaceId}/campaigns`)).data,
    enabled: !!workspaceId,
  });
}

export function usePacks(workspaceId) {
  return useQuery({
    queryKey: ["packs", workspaceId],
    queryFn: async () => (await api.get(`/api/workspaces/${workspaceId}/packs`)).data,
    enabled: !!workspaceId,
  });
}

export function useLibrary(workspaceId) {
  return useQuery({
    queryKey: ["library", workspaceId],
    queryFn: async () => (await api.get(`/api/workspaces/${workspaceId}/generations`)).data,
    enabled: !!workspaceId,
  });
}

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => (await api.get("/api/users/me")).data,
  });
}

export function useWorkspace(workspaceId) {
  return useQuery({
    queryKey: ["workspace", workspaceId],
    queryFn: async () => (await api.get(`/api/workspaces/${workspaceId}`)).data,
    enabled: !!workspaceId,
  });
}
